module.exports = {"complaintTypeSelectLabel":"Rodzaj zgłoszenia *"}


//////////////////
// WEBPACK FOOTER
// ./src/components/ComplaintTypeSelect/translate.json
// module id = 1242
// module chunks = 0